"use client";

/**
 * Types related to the UI layer of the application (components/store/views)
 */
export type LessonListItem = {
  programmeSlug: string;
  unitSlug: string;
  lessonSlug: string;
  exitQuizCount: number;
  isLegacy: boolean;
  lessonData: {
    keyLearningPoints?: { keyLearningPoint: string }[] | null;
    keywords?: { keyword: string; description: string }[] | null;
    misconceptionsAndCommonMistakes?:
      | {
          misconception?: string;
          response?: string;
        }[]
      | null;
    equipmentAndResources?: { equipment: string }[] | null;
    title: string;
  };
};

export type ProgrammeFields = {
  optionality?: string;
  year: string;
  yearSlug?: string | null;
  legacy?: string | null;
  tier?: string | null;
  tierSlug?: string | null;
  tierDisplayOrder?: number | null;
  tierDescription?: string | null;
  examboard?: string | null;
  examboardSlug?: string | null;
  examboardDisplayOrder?: number | null;
  pathway?: string | null;
  pathwaySlug?: string | null;
  pathwayDisplayOrder?: number | null;
  subject?: string | null;
  subjectSlug?: string | null;
  subjectDescription: string;
  phase: string;
  phaseSlug?: string | null;
};

export type UnitData = {
  title: string;
  description?: string | null;
};

export type Unit = {
  unitData: UnitData;
  lessonCount: number;
  isLegacy: boolean;
  unitSlug: string;
  programmeFields: ProgrammeFields;
};

export type NewAttachment = {
  courseId: string;
  itemId: string;
  addOnToken: string;
  title: string;
  lessonSlug: string;
  programmeSlug: string;
  unitSlug: string;
  maxPoints?: number;
};

export type FactorData = {
  factor: string | null;
  factorSlug: string | null;
  factorDisplayOrder: number | null;
  factorDescription: string | null;
  isLegacy: boolean;
};

export type Programme = {
  programmeSlug: string;
  yearSlug: string;
  programmeFields: ProgrammeFields & unknown;
};

export type Subject = {
  programmeSlug: string;
  baseSlug: string;
  isLegacy: boolean;
  features?: {
    nonCurriculum?: boolean;
  } | null;
  programmeFields: ProgrammeFields;
};

export type Year = {
  yearSlug: string;
  yearDescription: string;
  phase: "primary" | "secondary";
};

export enum AuthCookieKeys {
  AccessToken = "oak-gclassroom-token",
  Session = "oak-gclassroom-session",
  PupilAccessToken = "oak-gclassroom-pupil-token",
  PupilSession = "oak-gclassroom-pupil-session",
}
